/**
 * Typed access to Vite env vars, with a compile-time error if any required
 * value is missing at build time.
 */

function must(name: string): string {
  const v = import.meta.env[name];
  if (!v || typeof v !== 'string') {
    throw new Error(`Missing required env var: ${name}`);
  }
  return v;
}

export const ENV = {
  apiUrl: must('VITE_API_URL'),
  cognitoDomain: must('VITE_COGNITO_DOMAIN'),
  cognitoClientId: must('VITE_COGNITO_CLIENT_ID'),
  userPoolId: must('VITE_USER_POOL_ID'),
  // Explicitly development-only: Vite replaces DEV with false in production,
  // so this can never bypass Cognito in a deployed build.
  previewBypassAuth:
    import.meta.env.DEV && import.meta.env.VITE_PREVIEW_BYPASS_AUTH === 'true',
};

/** Origin of the running app (differs between localhost, CloudFront, custom domain). */
export function appOrigin(): string {
  return window.location.origin;
}
